import React, { useCallback, useEffect, useState } from "react";

import api from "../../util/panelApi";
import { baseURL, secretKey } from "../../util/config";
import { PageHead, Table } from "./kit";

const day = (v) => (v ? new Date(v).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) : "—");

/// Aktif VIP uyelerin tek listesi: tek tek ya da hepsini hemen kaldir.
const VipMembers = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    const r = await api.vipList();
    if (r?.status) setRows(r.data || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const [tiers, setTiers] = useState([]);
  const [g, setG] = useState({ id: "", level: 1, days: 30 });
  const hdr = { key: secretKey, Authorization: sessionStorage.getItem("token") || "" };
  useEffect(() => {
    fetch(`${baseURL}customFrame/admin/vipTiers`, { headers: hdr })
      .then((r) => r.json())
      .then((r) => r?.status && setTiers(r.tiers || []))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const ver = async () => {
    if (!g.id.trim()) return window.alert("ID yaz");
    if (!window.confirm(`${g.id} → VIP${g.level}, ${g.days} gün verilsin mi?`)) return;
    setBusy(true);
    const r = await fetch(`${baseURL}customFrame/admin/vip`, { method: "POST", headers: { ...hdr, "Content-Type": "application/json" }, body: JSON.stringify(g) })
      .then((x) => x.json())
      .catch(() => null);
    setBusy(false);
    if (!r?.status) return window.alert(r?.message || "Olmadı");
    window.alert(`${r.name} → VIP${r.level}, bitiş ${day(r.expiresAt)}`);
    setG({ ...g, id: "" });
    load();
  };

  const kaldir = async (v) => {
    if (!window.confirm(`${v.name} (${v.uniqueID || "—"}) VIP${v.level} kaldırılsın mı?`)) return;
    setBusy(true);
    const r = await api.vipRevokeAll(v._id);
    setBusy(false);
    if (!r?.status) return window.alert(r?.message || "Olmadı");
    load();
  };

  const hepsi = async () => {
    if (!window.confirm(`${rows.length} kişinin VIP'si hemen kaldırılsın mı?`)) return;
    setBusy(true);
    const r = await api.vipRevokeAll();
    setBusy(false);
    window.alert(r?.message || "Bitti");
    load();
  };

  return (
    <>
      <PageHead
        title="VIP Üyeler"
        sub={`Aktif VIP: ${rows.length}. Kaldırınca üyelik anında biter.`}
        right={
          rows.length > 0 && (
            <button type="button" className="btn btn-danger" disabled={busy} onClick={hepsi}>
              Hepsini kaldır
            </button>
          )
        }
      />
      <div className="card">
        <div className="card-body d-flex align-items-center" style={{ gap: 8, flexWrap: "wrap" }}>
          <b>VIP ver</b>
          <input style={{ padding: "7px 10px", border: "1px solid #E5E7EB", borderRadius: 8, width: 180 }} placeholder="Kullanıcı ID" value={g.id} onChange={(e) => setG({ ...g, id: e.target.value })} />
          <select style={{ padding: "7px 10px", border: "1px solid #E5E7EB", borderRadius: 8 }} value={g.level} onChange={(e) => setG({ ...g, level: Number(e.target.value) })}>
            {(tiers.length ? tiers : [{ level: 1, name: "VIP1" }]).map((t) => (
              <option key={t.level} value={t.level}>
                {t.name || `VIP${t.level}`}
              </option>
            ))}
          </select>
          <select style={{ padding: "7px 10px", border: "1px solid #E5E7EB", borderRadius: 8 }} value={g.days} onChange={(e) => setG({ ...g, days: Number(e.target.value) })}>
            {[1, 3, 7, 15, 30, 60, 90, 180, 365].map((d) => (
              <option key={d} value={d}>
                {d} gün
              </option>
            ))}
          </select>
          <button type="button" className="btn btn-primary" disabled={busy} onClick={ver}>
            Ver
          </button>
          <span style={{ fontSize: 12, color: "#6B7280" }}>Aynı seviyedeyse süre uzar. Uygulamada 1 dk içinde görünür.</span>
        </div>
      </div>
      <Table
        head={["Kişi", "ID", "Seviye", "Bitiş", ""]}
        loading={loading}
        empty="Aktif VIP üye yok."
        rows={rows.map((v) => (
          <tr key={v._id}>
            <td>{v.name}</td>
            <td>{v.uniqueID || "—"}</td>
            <td>VIP{v.level}</td>
            <td>{day(v.expiresAt)}</td>
            <td style={{ textAlign: "right" }}>
              <button type="button" className="btn btn-sm btn-outline-danger" disabled={busy} onClick={() => kaldir(v)}>
                Kaldır
              </button>
            </td>
          </tr>
        ))}
      />
    </>
  );
};

export default VipMembers;
